


const SectionDivider = () => {
  return (
    <div className="fn_cs_section_divider">
      <div className="divider">
        <span className="short" />
        <span className="long" />
        <span className="short" />
      </div>
    </div>
  );
};
export default SectionDivider;
